<template>
  <v-row class="pa-0 ma-0 po-r" id="banner" v-if="banner" >
      <v-col cols="12" v-if="banner.componentType && banner.componentType == 'text'"
        :style="{ backgroundImage: `url(${getImgURL(banner.data.imgLink)})`,
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'center',
        backgroundPosition: 'center',
        backgroundSize: 'cover','background-blend-mode': 'multiply',
        backgroundColor: '#00000010' }"
      class="banner d-flex justify-center align-center pa-0 ma-0 w-100 h-100 po-r">
      <!-- 'background-blend-mode': 'multiply',
        backgroundColor: '#00000015' -->
        <v-col cols="9" md="5" xl="4" class="banner_middle_BG-img pa-0 ma-0"></v-col>
        <!-- ↑背景 -->
          <v-row class="pa-0 ma-0  d-flex justify-center align-center z-1">
            <v-col cols="12"  md="10" xl="8" class="pa-0 ma-0">
            <!-- ↑限制寬 -->
              <v-row class="pa-0 ma-0  d-flex justify-start align-center">
                <v-col cols="12" sm="7" md="8" xl="6" class="pa-0 ma-0">
                <!-- ↑取一半 -->
                  <v-row class="pa-0 ma-3 ma-md-0 mb-0 mb-md-8 textShadow"
                  :style="{'color': getTColor,}" >
                    <v-col cols="12 " class="py-0 font-B " :class="isMobile? 'banner-font-h6':'banner-font-h5'" v-if="banner.data.openTitle && banner.data.openTitle == 'off'">
                        <h2 class="w-fit banner-font-h3" :class="isMobile? '':''">
                            {{ t(banner.data.title) }}　
                          <div class="w-100 text-right">
                            {{ t(banner.data.subtitle) }}
                          </div>
                        </h2>
                    </v-col>
                    <v-col cols="12" xs="7" md="7" class="py-0" v-else>
                        <div class="font-B" :class="isMobile? 'banner-font-h6':'banner-font-h5'">
                          <div class=" mb-0 pb-0 banner-font-h1"
                          :class="isMobile? '':''">{{ t(title.split('∞')[0]) }}<sup>∞</sup></div>
                          <div :class="isMobile? '':''"
                          class="banner-font-h2"
                          :style="{
                            marginTop: '-0.5em',
                            textTransform: 'capitalize',
                            }">{{ t(title.split('∞')[1]) }}</div>
                          <h2 v-if="banner.data.title" class="banner-font-h3 pb-3">{{ t(banner.data.title) }}</h2>
                        </div>
                    </v-col>
                  
                    <v-col cols="12" class="mb-md-9" v-if="banner.data.data.length != 0">
                      <p v-for="(text, textNum) in banner.data.data" :key="textNum"
                      class="mb-0 te-p text-justify " v-html="getInfinity(t(text.text))">
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
      </v-col>
      
      <!-- <v-col cols="12" class="pa-0 ma-0 po-r" v-else-if="banner.componentType && banner.componentType == 'img'">
      
        <v-carousel cycle interval="9000" height="85vh"
        hide-delimiter-background>
          <v-carousel-item  
            v-for="(item, i) in banner.data"
            :key="i" :src="getImgURL(item.imgLink)"
            reverse-transition="fade-transition"
            tarnsition="fade-transition">
            
            <div class="banner_middle_BG-img"></div>
            
            <v-row class="pa-0 ma-0  d-flex justify-center align-center h-100">
              <v-col cols="12"  md="10" xl="8" class="pa-0 ma-0 z-1">
              ↑限制寬
                <v-row class="pa-0 ma-0  d-flex justify-start align-center">
                  <v-col cols="12" sm="6" md="6" xl="5" class="pa-0 ma-0">
                  ↑取一半
                    <v-row class="pa-0 ma-3 ma-md-0">
                      <v-col cols="12" class="py-0" v-if="item.openTitle && item.openTitle == 'off'" >
                        <h2 class="w-fit">
                            {{ item.title }}　
                          <div class="w-100 text-right">
                            {{ item.subtitle }}
                          </div>
                        </h2>
                      </v-col>
                      <v-col cols="12" xs="6" md="6" class="py-0" v-else>
                          <h2>
                            <span class="font-h3 mb-0 pb-0">D<sup>∞</sup></span><br>
                            <span class="font-h5"> College</span>
                          </h2>
                      </v-col>
                    
                      <v-col cols="12" class="mb-md-1">
                        <p v-for="(text, textNum) in item.data" :key="textNum"
                        class="mb-0 te-p text-justify">
                          {{ text.text }}
                        </p>
                      </v-col>
                      <v-col cols="12" class="mb-md-1 d-flex justify-end" v-if="item.linkURL">
                        <a class=""
                        :title="item.linkURL" href="#">
                          MORE>>
                        </a>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-carousel-item>
        </v-carousel>

      </v-col> -->

      <v-col cols="12" class="banner_bottom_BG-img pa-0 ma-0"></v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  props: ["banner"],
  data:() =>({
    title: '',
    index:[
      {
        componentType: "text",
        data:{
          openTitle: "on",
          title: "數位學程科技",
          subtitle: "微學程",
          textColor: "",
          imgLink: "banner/DSC00164.jpg",
          data: [
            {
                "text":"“Those who can imagine anything, can create the impossible.” – Alan Turing, Computer Scientist"
            },
            {
                "text":"過D∞學院設置微學程"
            }
          ]
        }
      },
      {
        componentType: "img",
        data:[
          {
            openTitle: "off",
            title: "數位學程科技",
            subtitle: "微學程",
            textColor: "",
            imgLink: "banner/for2.jpg",
            data: [
                {
                    "text":"“Those who can imagine anything, can create the impossible.” – Alan Turing, Computer Scientist"
                },
                {
                    "text":"過D∞學院設置123微學程"
                }
              ],
            linkURL: {
                title: "前往敘事溝通",
                href: ""
            }
              
          },
          {
            openTitle: "no",
            title: "",
            subtitle: "",
            textColor: "",
            imgLink: "banner/75.jpg",
          },
          {
            openTitle: "off",
            title: "敘事溝通",
            subtitle: "微學程",
            textColor: "",
            imgLink: "banner/DSC00164.jpg",
          }
        ]
      }
    ]
  }), 
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; // 当屏幕宽度小于 "md" 断点时返回 true
    },
    getTColor() {

      let c = this.banner.data.textColor;

      if (c === '黑' || c === '黑色' || c === 'black') {
        return '#000';
      } else if (c === '' || c === '白' || c === '白色' || c === 'white') {
        return '#FFF';
      } else {
        return c;
      }
    },
  },
  mounted() {
    axios
      .get("/tools/json/menu.json")
      .then((response) => {
        this.title = response.data[1].name;
    })
  },
  methods: {
    //檢查圖片網址
    getImgURL(URL) {
      if(URL.includes('https')){
        return URL;
      }else{
        return `/tools/img/${URL}`;
      }
    },

    //檢查∞符號
    getInfinity(text){
      if (text && text.includes('∞') > -1) {
        let tAll = text.split('∞');
        let result = tAll.join('<sup>∞</sup>');
        return result;
      } else {
        return text; // 如果文本中不存在∞符號，直接返回原始文本
      }
    },

  }
};
</script>

<style lang="scss">
.banner{
  background-image: url("../../public/tools/img/doNotTouch/BG-infinityb.svg");
  height: 75vh;
}
.banner_middle_BG-img{
  position: absolute;
  // width: 75vw;
  height: 65vh;
  background-image: url("../../public/tools/img/doNotTouch/BG-infinityb.svg");
  background-position: left;
  background-size: contain;
  opacity: 0.3;
  bottom: -25px;
  left: 0px;
}
.banner_bottom_BG-img{
  position: absolute;
  background-image: url("../../public/tools/img/doNotTouch/indexBg_standard_down.svg");
  background-position: bottom;
  background-size: contain;
  bottom: -1px;
  left: 0px;
  height: 25%;
}
.banner_text {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: flex-start;
  margin-top: 8px;
}

.banner_title {
  margin-bottom: 0; /* 調整標題與副標題的間距 */
}

.banner_subtitle {
  align-self: flex-start;
  margin-top: 0; /* 調整標題與副標題的間距 */
  white-space: pre-wrap; /* 允許換行 */
}
.textShadow{
  text-shadow: #585858 1px 1px 3px;
  p{
    text-shadow: #000000 1px 1px 8px;
  }
}
.banner-font-h1{
  font-size: 5.9em;
}
.banner-font-h2{
  font-size: 4.0em;
}
.banner-font-h3{
  font-size: 3.4em;
}
// .banner-font-h4{
// font-size: 2.9em;
// }
.banner-font-h5{
  font-size: 1.05em;
}
.banner-font-h6{
  font-size: 0.85em;
}
</style>